import React from 'react'

export default function Container11() {
  return (
    <div className='container-fluid  mt-5 py-5 footerbg '>
        <div className='container'>
        <div className='row'>
        <div className='col-lg-3 col-md-3 col-sm-12 px-5 my-3'>
            <p className='hd  hcolor  '><span className='pt-1 me-2 pe-1  line-footer  text-success1'></span>Adresse</p>
            <header className='text-dark'></header>
            <p className='hcolor'><span className='fw-bold '>Pii</span>SCREEN WERBENETZWERK
                GmbH LoebstraBe 15 - 54292 Tier
            </p>
            <p className='hcolor footer-link'><i className='fas fa-phone-square'></i><a href='tel:+496516034240' className='mx-1 footer-link'>+49 651 6034240</a></p>
            <p className='hcolor footer-link'><i className='fas fa-envelope-open'></i><a href="mailto:werbenetzwerk@piiscreen.de" className='mx-1 footer-link'>werbenetzwerk@piiscreen.de</a></p>
        </div>
        <div className='col-lg-3 col-md-3 col-sm-12 px-5 my-3'>
        <p className='hd  hcolor'><span className=' pt-1 me-2 pe-1 line-footer text-success1 '></span>Mitgliedschaften</p>
            <header className='text-dark'></header>
            <ul>
                <li className='py-2 hcolor'><a href='https://www.mctl.eu/' className='footer-link'>Marketing club Trier</a></li>
                <li className='py-2 hcolor'><a href='https://www.kju-trier.de/' className='footer-link'>KJU Trier</a></li>
                <li className='py-2 hcolor'><a href='https://mitl-netzwerk.eu/' className='footer-link'>mitl | Medien -und IT-Netzwerk</a></li>
            </ul>
        </div>
        <div className='col-lg-6 col-md-6 col-sm-12 px-5 my-3'>
        <p className='hd  hcolor'><span className=' pt-1 me-2 pe-1 line-footer text-success1'> </span>So einfach war Werbung noch nie</p>
            <header className='text-dark'></header>
            <p className='hcolor'>Du möchtest das <span className='hcolor fw-bold'>Pii</span>SCREEN-Werbenetzwerk gerne einmal ausprobieren? Kein Problem. Vereinbare einfach einen kostenlosen und unverbindlichen Beratungstermin mit uns und wir zeigen dir, was möglich ist - und zwar genau abgestimmt auf deine Branche.
            </p>
            <a href='https://werbenetzwerk.piiscreen.de/kontakt-formular' className='flinktext text-success1'><button className='btn btn-success'>Jetzt kontaktieren
</button></a>
        </div>
        </div>
        </div>
    </div>
  )
}
